import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Divider,
  FormControlLabel,
  Grid,
  Hidden,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Modal,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import moment from "moment";
import "moment-timezone";
import { Formik } from "formik";
import makeStyles from "@mui/styles/makeStyles";

import { BCPXmark, BCPAngleDown } from "../icons/bcp/BCPIcons";

import ListResponsive from "../other/ListResponsive";
import {
  getRegionName,
  findRegionHierarchy,
  handlePagingAll,
  getRegion,
  getGlobalRegion,
} from "../api/APIUtilities";
import { postNotification } from "../utilities/Notifications";
import StyledMenu from "../layout/StyledMenu";
import ModalLoadingFull from "../modals/ModalLoadingFull";
import { useConfirm } from "material-ui-confirm";
import DatePickerComponent from "../utilities/DatePickerComponent";
import { delay, getData, postData } from "../utilities/UtilityFunctions";
import { AuthContext } from "../user/BCPAuthProvider";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import ModalLoadingMessage from "../modals/ModalLoadingMessage";
import { getCookie, setCookie } from "../layout/cookies/CookieFunctions";
import ExternalLink from "../utilities/ExternalLink";

const useStyles = makeStyles((theme) => ({
  container: { textAlign: "center" },
  image: {
    maxHeight: "300px",
    width: "300px",
    maxWidth: "90%",
  },
  ButtonGroupContainer: {
    marginBottom: theme?.spacing ? theme.spacing(1) : null,
    "& .MuiButton-root:not(:last-of-type)": {
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      borderRight: `1px solid ${theme?.palette?.primary?.dark}`,
    },
    "& .MuiButton-root:not(:first-of-type)": {
      borderTopLeftRadius: "0",
      borderBottomLeftRadius: "0",
      borderLeft: `1px solid ${theme?.palette?.primary?.dark}`,
    },
  },
  ButtonMenuArrow: {
    minWidth: "35px",
    paddingLeft: theme?.spacing ? theme.spacing(1) : null,
    paddingRight: theme?.spacing ? theme.spacing(1) : null,
  },
}));

const defaultRegion = { id: "VgQKgqmTPU", name: "United States" };
const globalRegion = getGlobalRegion();

export default function RankingsGroupWidget(props) {
  const classes = useStyles();

  const {
    isGameSystem,
    isArmy,
    leagueId,
    regions,
    regionId,
    league,
    numberOfEvents,
    doSearch,
    doPages,
    rowsPerPage,
    embed,
    hideImage,
    hideTitle,
    hidePoweredBy,
    hideRegionPicker,
    disableCookieSet,
    placingsType,
    ...rest
  } = props;

  const theme = useTheme();
  const [rows, setRows] = useState(null);
  const [tempRows, setTempRows] = useState(null);
  var cookieRegionId =
    getCookie("rankingsRegion") ||
    league?.defaultRegion?.id ||
    (league?.gw_itc ? defaultRegion?.id : globalRegion?.id);
  const cookieRegion = getRegion(
    props?.region || regionId || cookieRegionId,
    regions
  );

  const [region, setRegion] = useState(props?.region || cookieRegion);
  const regionName = getRegionName(regionId || cookieRegionId, regions);
  const [photo, setPhoto] = useState(null);
  const [parentRegion, setParentRegion] = useState(null);
  const [hierarchy, setHierarchy] = useState(null);
  var [regionsMenu, setRegionsMenu] = useState(null);

  const [manageCorrections, setManageCorrections] = useState(false);
  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [correctionType, setCorrectionType] = useState(null);
  const [correction, setCorrection] = useState(null);
  const [processing, setProcessing] = useState(false);

  const [refresh, setRefresh] = useState(false);

  const numEvents = numberOfEvents
    ? numberOfEvents
    : league?.teams
      ? 10
      : league?.numPlayerPlacings && !isArmy
        ? league?.numPlayerPlacings
        : league?.numFactionPlacings && isArmy
          ? league?.numFactionPlacings
          : league.itc
            ? 5
            : 4;

  // const authContext = useContext(AuthContext);
  var authContext = useContext(AuthContext);
  const confirm = useConfirm();

  const setCookies = async () => {
    if (disableCookieSet) {
      return;
    }
    try {
      if (authContext?.authState?.cookieConsent) {
        setCookie("rankingsRegion", region.id || region.regionId);
      }
    } catch (err) {}
  };

  const go = async () => {
    // get the players / teams
    // regions
    setRows(null);

    if (!hierarchy) {
      const _hierarchy = findRegionHierarchy(
        regions,
        regionId || cookieRegionId
      );
      setHierarchy(_hierarchy);
    }

    if (region) {
      setCookies();
    }

    if (
      !league?.topX &&
      (authContext?.authState?.identity?.isAdmin === true ||
        league?.gameStoreUser?.owner ||
        (league?.gameStoreUser?.active && league?.gameStoreUser?.corrections) ||
        (league?.gameSystemId &&
          authContext?.authState?.identity?.adminGameSystems?.length > 0 &&
          authContext?.authState?.identity?.adminGameSystems.includes(
            league?.gameSystemId
          )))
    ) {
      setManageCorrections(true);
    }

    if (league?.photoFileId) {
      var apiPhoto = await getData(`/files/${league.photoFileId}`, {
        queryStringParameters: {
          //resize type?
        },
      });
      if (apiPhoto) {
        setPhoto(apiPhoto);
      }
    }
    if (league.delay) {
      await delay(league.delay * 1000);
    }
    var apiData;
    var queryStringParameters = {
      placingsType: placingsType
        ? placingsType
        : league.teams
          ? "team"
          : isArmy
            ? "army"
            : league.defaultPlacingType === "ELO Points"
              ? "elo"
              : "player",
      leagueId: leagueId,
      limit: league.topX || 3000,
      sortAscending: false,
    };

    if (regions?.length > 0) {
      if (props?.region?.id || region?.id || region?.regionId) {
        queryStringParameters.regionId =
          props?.region?.id || region?.id || region.regionId;
      } else if (cookieRegionId) {
        queryStringParameters.regionId = cookieRegionId;
      }
    } else if (regionId) {
      queryStringParameters.regionId = regionId;
    }
    if (isArmy) queryStringParameters.armyId = league.id;

    if (league.teams) {
      // queryStringParameters["expand[]"] = ["team"];

      if (league.topX) {
        let apiFetch = await getData(`/placings`, {
          queryStringParameters: queryStringParameters,
        });
        apiData = apiFetch.data;
      } else {
        apiData = await handlePagingAll(
          `/placings`,
          queryStringParameters,
          setTempRows
        );
      }
    } else {
      // queryStringParameters["expand[]"] = ["user"];

      if (league.topX) {
        let apiFetch = await getData(`/placings`, {
          queryStringParameters: queryStringParameters,
        });
        apiData = apiFetch.data;
      } else {
        apiData = await handlePagingAll(
          `/placings`,
          queryStringParameters,
          setTempRows
        );
      }
    }
    if (league.topX && apiData.length > league.topX) {
      apiData = apiData.slice(0, league.topX);
    }

    // apiData = apiData.map((el, i) => {
    //   return {
    //     placing: i + 1,
    //     ...el,
    //   };
    // });

    setRows(apiData);
    setTempRows(null);
  };

  useEffect(() => {
    go();
    // eslint-disable-next-line
  }, [league, leagueId, region, props?.region]);

  useEffect(() => {
    const doCorrection = async () => {
      if (correctionType === "mergeUsers") {
        if (!correction.primary || !correction.secondary) {
          // not ready
          return;
        }

        try {
          await confirm({
            title: `Are you sure?`,
            description: `Are you sure you want to merge all the results for ${
              league.teams
                ? correction.secondary.name
                : `${correction.secondary.firstName} ${correction.secondary.lastName} (secondary user)`
            } into ${
              league.teams
                ? correction.primary.name
                : `${correction.primary.firstName} ${correction.primary.lastName} (primary user)`
            }? This will only affect the current circuit`,
            dialogProps: {
              sx: {
                zIndex: 99999,
              },
            },
          });
        } catch (err) {
          return;
        }

        setProcessing(true);
        try {
          await postData(
            `/leagues/${league.id}/${league.teams ? "mergeTeam" : "mergeUser"}`,
            {
              body: {
                primaryId: correction.primary.id,
                secondaryId: correction.secondary.id,
              },
            }
          );

          await delay(3000);
          setRefresh(true);
          setCorrectionType(null);
        } catch (err) {
          postNotification("error", err);
        }
        setProcessing(false);
      } else if (correctionType === "suspendUser") {
        if (!correction.user) {
          // not ready
          return;
        }

        try {
          await confirm({
            title: `Are you sure?`,
            description: `Are you sure you want to suspend ${correction.user.firstName} ${correction.user.lastName}? This will only affect the current circuit`,
            dialogProps: {
              sx: {
                zIndex: 99999,
              },
            },
          });
        } catch (err) {
          return;
        }

        setProcessing(true);
        try {
          var body = {
            userId: correction.user.id,
            reason: "",
            expiryDate: correction.expiryDate,
            zeroPastEvents: correction.zeroPastEvents,
          };
          if (correction.reason) {
            body.reason = correction.reason;
          }
          await postData(`/leagues/${league.id}/suspendUser`, {
            body: body,
          });

          await delay(3000);
          setRefresh(true);
          setCorrectionType(null);
        } catch (err) {
          postNotification("error", err);
        }
        setProcessing(false);
      }
    };

    if (correction) {
      doCorrection();
    }
    // eslint-disable-next-line
  }, [correction]);

  useEffect(() => {
    setCorrection(null);
  }, [correctionType]);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
      go();
    }
    // eslint-disable-next-line
  }, [refresh]);
  return (
    <Box sx={{ pt: 2, pb: 2 }}>
      {!hideImage && (
        <Box>
          <img
            src={
              league?.itc && isArmy && league?.ITCImageURL
                ? league.ITCImageURL
                : league.photo?.url ||
                  photo?.url ||
                  league.imageUrl ||
                  `${getEnvironmentVariable(
                    "SYSTEM_IMAGES_CLOUDFRONT"
                  )}/images/RankingsImage${
                    theme?.palette?.mode === "dark" ? "Dark" : ""
                  }.png`
            }
            alt={league.name}
            className={classes.image}
          />
        </Box>
      )}

      {!hideTitle && (
        <Box className={classes.row}>
          {regions?.length > 0 && hierarchy?.length > 1 ? (
            <Typography variant="h2" gutterBottom>
              {league.name}
              {hierarchy.map((h, i) => {
                return (
                  <>
                    {" "}
                    -{" "}
                    {i === hierarchy?.length - 1 ? (
                      `${h.name}`
                    ) : (
                      <Link
                        onClick={() => {
                          const _heierarchy = findRegionHierarchy(
                            regions,
                            h.id
                          );
                          setRegion(h);
                          setHierarchy(_heierarchy);
                        }}
                      >
                        {h.name}
                      </Link>
                    )}
                  </>
                );
              })}
            </Typography>
          ) : (
            <Typography variant="h2" gutterBottom>
              {`${league.name}${
                regions?.length > 0 && region?.name
                  ? ` - ${region.name}`
                  : regions?.length > 0 && regionName
                    ? ` - ${regionName}`
                    : ""
              }`}
            </Typography>
          )}
        </Box>
      )}

      <Box>
        {!hidePoweredBy && (
          <Typography variant="body1" gutterBottom>
            Powered by{" "}
            <Link
              target="_blank"
              href={`${window.location.protocol}//${window.location.host}`}
              underline="none"
            >
              {getEnvironmentVariable("COMPANY_NAME")}
            </Link>
          </Typography>
        )}

        {!hideRegionPicker && (
          <>
            {!regionId &&
              regions &&
              league.defaultPlacingType !== "ELO Points" && (
                <Box className={classes.ButtonGroupContainer}>
                  {regions.map((reg, index) => {
                    return (
                      <Button
                        variant="contained"
                        color="primary"
                        key={index}
                        onClick={(e) => {
                          if (reg.children?.length > 0) {
                            setParentRegion(reg);
                            setRegionsMenu(e.currentTarget);
                          } else {
                            setRegion(reg);
                            setHierarchy([reg]);
                          }
                        }}
                        endIcon={
                          reg.children?.length > 0 ? <BCPAngleDown /> : null
                        }
                      >
                        {reg.name}
                      </Button>
                    );
                  })}

                  <Menu
                    id="regions-menu"
                    open={Boolean(regionsMenu)}
                    anchorEl={regionsMenu}
                    onClose={() => {
                      setRegionsMenu(null);
                      setParentRegion(null);
                    }}
                    className={classes.regionsMenu}
                    disableAutoFocusItem
                  >
                    <MenuItem
                      onClick={async (e) => {
                        setRegion(parentRegion);
                        setHierarchy([parentRegion]);
                        setRegionsMenu(null);
                        setParentRegion(null);
                      }}
                      sx={{ fontWeight: 800 }}
                    >
                      {parentRegion?.name}
                    </MenuItem>
                    <Divider />
                    {parentRegion?.children &&
                      parentRegion.children.map((child, index) => (
                        <>
                          <MenuItem
                            key={index}
                            onClick={async (e) => {
                              setRegion(child);
                              setHierarchy([parentRegion, child]);
                              setRegionsMenu(null);
                              setParentRegion(null);
                            }}
                            sx={{ ml: 1, fontWeight: 600 }}
                          >
                            {child.name}
                          </MenuItem>
                          {child.children?.length > 0 && (
                            <>
                              <Divider />
                              {child.children.map((subMenuItem, i) => (
                                <MenuItem
                                  key={i}
                                  onClick={async (e) => {
                                    setRegion(subMenuItem);
                                    setHierarchy([
                                      parentRegion,
                                      child,
                                      subMenuItem,
                                    ]);
                                    setRegionsMenu(null);
                                    setParentRegion(null);
                                  }}
                                  sx={{
                                    ml: 2,
                                    fontStyle: "italic",
                                    fontWeight: 350,
                                  }}
                                >
                                  {subMenuItem.name}
                                </MenuItem>
                              ))}
                            </>
                          )}
                        </>
                      ))}
                  </Menu>
                </Box>
              )}
          </>
        )}

        <Box sx={{ p: 1 }}>
          <ListResponsive
            originalList={rows}
            doSearch={doSearch}
            doPages={doPages}
            initialRowsPerPage={rowsPerPage}
            actionButton={
              !manageCorrections
                ? null
                : [
                    {
                      props: {
                        variant: "outlined",
                        color: "primary",
                        fullWidth: true,
                        "aria-expanded": Boolean(optionsAnchorEl)
                          ? true
                          : undefined,
                        onClick: (e) => {
                          setOptionsAnchorEl(e.currentTarget);
                        },
                        endIcon: <BCPAngleDown />,
                      },
                      label: "Options",
                    },
                  ]
            }
            searchProps={{
              label: "Search Players",
              performSearch: (originalList, searchText) => {
                if (!searchText || searchText === "") {
                  return originalList;
                } else {
                  var filteredList = originalList.filter(function (el) {
                    if (el?.user?.firstName?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.user?.lastName?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.team?.name?.toLowerCase().includes(searchText))
                      return true;
                    return false;
                  });
                  return filteredList;
                }
              },
            }}
            rowProps={{
              headings: (
                <Grid
                  item
                  xs={12}
                  sx={{
                    p: "2px",
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: "4px 4px 0 0",
                    backgroundColor: "table.headerBackground",
                    color: "table.headerColor",
                  }}
                >
                  <ListRow
                    heading
                    league={league}
                    numEvents={numEvents}
                    leagueId={leagueId}
                    embed={embed}
                    correctionType={correctionType}
                    correction={correction}
                  />
                </Grid>
              ),
              mapFunction: (row, index) => (
                <Grid
                  item
                  xs={12}
                  key={index}
                  sx={{
                    p: "2px",
                    //mb: 1,
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                    //borderRadius: 1,
                  }}
                >
                  <ListRow
                    row={row}
                    index={index}
                    league={league}
                    numEvents={numEvents}
                    leagueId={leagueId}
                    embed={embed}
                    correctionType={correctionType}
                    correction={correction}
                    setCorrection={setCorrection}
                  />
                </Grid>
              ),
            }}
            {...rest}
          />
          {!doPages && (
            <Typography variant="caption" gutterBottom>
              {league.teams ? (
                <Link
                  href={`/rankings/teams?league=${leagueId}${
                    regionId ? `&region=${regionId}` : ""
                  }${embed ? "&embed=true" : ""}`}
                  underline="none"
                >
                  {`... complete team listing${
                    league.defaultPlacingType !== "ELO Points"
                      ? " with regions"
                      : ""
                  }`}
                </Link>
              ) : isGameSystem ? (
                <Link
                  href={`/rankings/${leagueId}?${
                    regionId ? `&region=${regionId}` : ""
                  }${embed ? "&embed=true" : ""}`}
                  underline="none"
                >
                  ... complete system rankings
                </Link>
              ) : (
                <Link
                  href={`/rankings/players?league=${leagueId}${
                    regionId ? `&region=${regionId}` : ""
                  }${isArmy ? `&army=${league?.id}` : ""}${
                    embed ? "&embed=true" : ""
                  }`}
                  underline="none"
                >
                  {`... complete listing${
                    league.defaultPlacingType !== "ELO Points"
                      ? " with regions"
                      : ""
                  }`}
                </Link>
              )}
            </Typography>
          )}
        </Box>
      </Box>
      {manageCorrections && (
        <OptionsMenu
          anchorEl={optionsAnchorEl}
          setAnchorEl={setOptionsAnchorEl}
          league={league}
          setCorrectionType={setCorrectionType}
        />
      )}
      {processing && <ModalLoadingFull />}
      {tempRows !== null ? (
        <ModalLoadingMessage
          header="Loading Placings"
          message={`Found ${tempRows?.length} Placing Records...`}
          open
        />
      ) : (
        <></>
      )}
    </Box>
  );
}

function OptionsMenu(props) {
  const { league, anchorEl, setAnchorEl, setCorrectionType } = props;

  const open = Boolean(anchorEl);
  return (
    <>
      <StyledMenu
        id="options-menu"
        MenuListProps={{
          "aria-labelledby": "options-button",
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={async (e) => {
            setCorrectionType("mergeUsers");
            setAnchorEl(null);
          }}
          disableRipple
        >
          Merge {league.teams ? "Teams" : "Users"}
        </MenuItem>
        {!league.teams && (
          <MenuItem
            onClick={async (e) => {
              setCorrectionType("suspendUser");
              setAnchorEl(null);
            }}
            disableRipple
          >
            Suspend User
          </MenuItem>
        )}
      </StyledMenu>
    </>
  );
}

const ListRow = (props) => {
  const {
    heading,
    row,
    league,
    numEvents,
    leagueId,
    embed,
    correctionType,
    correction,
    setCorrection,
  } = props;

  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      sx={{
        fontSize: "14px",
        //wordBreak: "break-all",
        //overflowWrap: "break-word",
        overflow: "hidden",
        textAlign:
          getEnvironmentVariable("COMPANY_FLAG") === "solforge"
            ? "left"
            : "center",
      }}
    >
      <Grid item xs sx={{ maxWidth: ["50px", "70px"] }}>
        {heading ? "Rank" : row.placing}
      </Grid>
      {getEnvironmentVariable("COMPANY_FLAG") === "solforge" &&
        !league.teams && (
          <Grid
            item
            xs
            sx={{ maxWidth: ["50px", "125px"], overflow: "hidden" }}
          >
            {heading ? (
              "User"
            ) : (
              <ExternalLink
                href={`/user/${row?.userId || row?.user?.id}?${
                  leagueId ? `&league=${leagueId}` : ""
                }${embed ? "&embed=true" : ""}`}
                target="_blank"
                underline="none"
                sx={{ display: "flex" }}
              >
                <Avatar
                  alt={`${row.user?.firstName} ${row.user?.lastName}`}
                  src={row.user?.profileImageUrl}
                  sx={{ width: 24, height: 24, mr: 1 }}
                />
                {row.user?.nickname && (
                  <Hidden smDown>{row.user?.nickname}</Hidden>
                )}
              </ExternalLink>
            )}
          </Grid>
        )}
      <Grid item xs sx={{ maxWidth: ["125px", "unset"], overflow: "hidden" }}>
        {heading ? (
          league.teams ? (
            "Club Name"
          ) : (
            "First Name"
          )
        ) : league.teams ? (
          <ExternalLink
            href={`/team/${row?.teamId || row?.team?.id}?${
              leagueId ? `&league=${leagueId}` : ""
            }${embed ? "&embed=true" : ""}`}
            target="_blank"
            underline="none"
          >
            {row.team?.name}
          </ExternalLink>
        ) : (
          <ExternalLink
            href={`/user/${row?.userId || row?.user?.id}?${
              leagueId ? `&league=${leagueId}` : ""
            }${embed ? "&embed=true" : ""}`}
            target="_blank"
            underline="none"
          >
            {row.user?.firstName}
          </ExternalLink>
        )}
      </Grid>
      <Grid item xs sx={{ maxWidth: ["125px", "unset"], overflow: "hidden" }}>
        {heading ? (
          league.teams ? (
            "Club Code"
          ) : (
            "Last Name"
          )
        ) : league.teams ? (
          <ExternalLink
            href={`/team/${row?.teamId || row?.team?.id}?${
              leagueId ? `&league=${leagueId}` : ""
            }${embed ? "&embed=true" : ""}`}
            target="_blank"
            underline="none"
          >
            {row.team?.shortName || "-"}
          </ExternalLink>
        ) : (
          <ExternalLink
            href={`/user/${row?.userId || row?.user?.id}?${
              leagueId ? `&league=${leagueId}` : ""
            }${embed ? "&embed=true" : ""}`}
            target="_blank"
            underline="none"
          >
            {row.user?.lastName}
          </ExternalLink>
        )}
      </Grid>
      <Grid item xs sx={{ maxWidth: ["unset", "65px", "unset"] }}>
        {heading
          ? "Points"
          : Math.round(
              (league?.texasMasters
                ? row.TexasMastersPoints || 0
                : row.ITCPoints !== undefined
                  ? row.ITCPoints
                  : row.BCPPoints !== undefined
                    ? row.BCPPoints
                    : row.ELOPoints !== undefined
                      ? row.ELOPoints
                      : 0) * 100
            ) / 100}
      </Grid>
      {league.solforgeLeague ? (
        <Grid item xs sx={{ maxWidth: ["55px", "75px", "unset"] }}>
          {heading ? "Matches" : row.wins + row.ties + row.losses}
        </Grid>
      ) : (
        <Grid item xs sx={{ maxWidth: ["55px", "75px"] }}>
          {heading
            ? "Events"
            : row.allPlacingsByStartedTime
              ? row.allPlacingsByStartedTime.length
              : `${
                  row.usedPlacings
                    ? Object.keys(row.usedPlacings).length
                    : row.eventPlacings?.length || 0
                }${
                  !league?.jascoLeague && !league?.solforgeLeague
                    ? ` of ${numEvents}`
                    : ""
                }`}
        </Grid>
      )}
      {correctionType && (
        <Grid item xs>
          {heading ? (
            "Select"
          ) : correctionType === "mergeUsers" ? (
            <MergeUserCorrection
              teams={league.teams}
              row={row}
              correction={correction}
              setCorrection={setCorrection}
            />
          ) : correctionType === "suspendUser" ? (
            <SuspendUserCorrection
              user={row.user}
              setCorrection={setCorrection}
            />
          ) : null}
        </Grid>
      )}
    </Grid>
  );
};

const MergeUserCorrection = (props) => {
  const { teams, row, correction, setCorrection } = props;

  if (!correction?.primary) {
    return (
      <Button
        fullWidth
        variant="outlined"
        color="primary"
        onClick={() => {
          if (!teams) {
            if (!row.user.active) {
              postNotification(
                "warning",
                "Only active users can be set as a Primary User."
              );
              return;
            }
            setCorrection({ primary: row.user });
          } else {
            setCorrection({ primary: row.team });
          }
        }}
      >
        Primary {teams ? "Team" : "User"}
      </Button>
    );
  }
  if (
    (teams && correction.primary?.id === row.team?.id) ||
    (!teams && correction.primary?.id === row.user?.id)
  ) {
    return (
      <Button fullWidth variant="contained" color="primary">
        Primary {teams ? "Team" : "User"}
      </Button>
    );
  }
  if (
    (teams && correction.secondary?.id === row.team?.id) ||
    (!teams && correction.secondary?.id === row.user?.id)
  ) {
    return (
      <Button fullWidth variant="contained" color="secondary">
        Secondary {teams ? "Team" : "User"}
      </Button>
    );
  }
  return (
    <Button
      fullWidth
      variant="outlined"
      color="secondary"
      onClick={() => {
        setCorrection({
          ...correction,
          secondary: teams ? row.team : row.user,
        });
      }}
    >
      Secondary {teams ? "Team" : "User"}
    </Button>
  );
};

const SuspendUserCorrection = (props) => {
  const { user, setCorrection } = props;
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        fullWidth
        variant="outlined"
        color="primary"
        onClick={() => {
          setOpen(true);
        }}
      >
        Suspend User
      </Button>
      {open && (
        <Modal
          disableAutoFocus
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: ["95vw", "85vw", 600],
              //minHeight: "95vh",
              maxHeight: "95vh",
              overflowY: "scroll",
              bgcolor: "background.paper",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 24,
              p: 4,
            }}
          >
            <IconButton
              aria-label="cancel"
              color="error"
              sx={{ position: "absolute", top: "4px", right: "4px" }}
              onClick={() => {
                setOpen(false);
              }}
            >
              <BCPXmark />
            </IconButton>
            <Grid
              container
              spacing={2}
              sx={{
                pb: 1,
                mb: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            >
              <Grid item xs>
                <Typography variant="h4" component="h2">
                  Suspension Details
                </Typography>
              </Grid>
            </Grid>

            <Formik
              initialValues={{
                user: user,
                reason: "",
                startDate: new Date(moment()),
                expiryDate: new Date(moment().add(1, "year")),
                zeroPastEvents: false,
              }}
              enableReinitialize={true}
              onSubmit={async (values) => {
                setCorrection(values);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
                setFieldValue,
                submitForm,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      pb: 1,
                      mb: 2,
                    }}
                  >
                    <Grid item xs={12}>
                      <DatePickerComponent
                        name="startDate"
                        label="Suspension Start"
                        value={values.startDate}
                        setFieldValue={setFieldValue}
                        error={Boolean(
                          touched.startDate && values.startDate === ""
                        )}
                        helperText={
                          touched.startDate && values.startDate === ""
                            ? "Required"
                            : null
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <DatePickerComponent
                        name="expiryDate"
                        label="Suspension Expiry"
                        value={values.expiryDate}
                        setFieldValue={setFieldValue}
                        error={Boolean(
                          touched.expiryDate && values.expiryDate === ""
                        )}
                        helperText={
                          touched.expiryDate && values.expiryDate === ""
                            ? "Required"
                            : null
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        name="reason"
                        label="Suspension Reason"
                        value={values.reason}
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={3}
                        margin="normal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(touched.reason && errors.reason)}
                        helperText={touched.reason && errors.reason}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        label={
                          <Typography className="MuiFormControlLabel-label">
                            Zero Out Past Events
                          </Typography>
                        }
                        sx={{
                          ml: 0,
                          width: "100%",
                          "& .MuiFormControlLabel-label": {
                            width: "calc(100% - 58px)",
                          },
                        }}
                        control={
                          <Switch
                            checked={values.zeroPastEvents}
                            onChange={(e) => {
                              setFieldValue(
                                "zeroPastEvents",
                                !values.zeroPastEvents
                              );
                            }}
                          />
                        }
                        labelPlacement="start"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Button
                        color="error"
                        variant="outlined"
                        fullWidth
                        onClick={() => {
                          setOpen(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        fullWidth
                      >
                        Suspend
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          </Box>
        </Modal>
      )}
    </>
  );
};
